// Code for both android and IOS
import { sygnalAppId, sygnalApiEndpoint } from '../constants.js'

async function getPusher (matrixClient, appId, uniqueDeviceId) {
  try {
    const result = await matrixClient.getPushers()

    return result.pushers.find(
      p =>
        p.app_id === appId &&
        p.profile_tag === uniqueDeviceId
    ) || null
  } catch (err) {
    // console.log('RJMDEBUG913 Matrix user:', matrixClient.getUserId())
    // console.log('RJMDEBUG913 Matrix device:', matrixClient.getDeviceId())
    // console.log('RJMDEBUG913 has token:', !!matrixClient.getAccessToken())
    // console.log('RJMDEBUG913 token length:', matrixClient.getAccessToken()?.length)
    console.log('RJMDEBUG913 ERROR Failed to get pushers:', err)
    return null
  }
}

export async function removePusher (matrixClient, plugin) {
  let uniqueDeviceId

  try {
    const pluginCallResult = await plugin.getUniqueDeviceId()
    uniqueDeviceId = pluginCallResult?.uniqueDeviceId
  } catch (err) {
    console.log('RJMDEBUG900 ERROR removePusher failed getting device ID', err)
    return
  }

  if (!uniqueDeviceId) {
    // console.log('RJMDEBUG900 removePusher no device ID')
    return
  }

  // console.log('RJMDEBUG200 removePusher device ID:', uniqueDeviceId)

  const pusher = await getPusher(
    matrixClient,
    sygnalAppId,
    uniqueDeviceId
  )

  if (!pusher) {
    console.log('RJMDEBUG900 removePusher no existing pusher')
    return
  }

  try {
    await matrixClient.removePusher(
      pusher.pushkey,
      pusher.app_id
    )

    // console.log('RJMDEBUG200 removePusher deleted')
  } catch (err) {
    console.log('RJMDEBUG900 ERROR removePusher failed:', err)
  }
}

export async function registerPushToken ({ matrixClient, tokenValue }) {
  console.log('RJMDEBUG900 registerPushToken')
  // console.log('RJMDEBUG200 -', tokenValue)

  const plugin = window.Capacitor.Plugins.FirebasePushToken
  if (!plugin) {
    console.log('RJMDEBUG900 ERROR FirebasePushToken plugin not available')
    return
  }
  const pluginCallResult = await plugin.getUniqueDeviceId()
  let uniqueDeviceId
  try {
    uniqueDeviceId = pluginCallResult?.uniqueDeviceId
  } catch (err) {
    console.log('RJMDEBUG900 ERROR Failed getting device ID', err)
    return
  }
  if (!uniqueDeviceId) {
    console.log('RJMDEBUG900 ERROR FirebasePushToken.getUniqueDeviceId did not return a device ID')
    return
  }
  // console.log('RJMDEBUG900 got unique device ID:', uniqueDeviceId)

  const existingPusher = await getPusher(
    matrixClient,
    sygnalAppId,
    uniqueDeviceId
  )

  if (existingPusher) {
    if (existingPusher.pushkey === tokenValue) {
      // console.log('RJMDEBUG200 no change in push token')
      return
    }

    try {
      await matrixClient.removePusher(
        existingPusher.pushkey,
        existingPusher.app_id
      )

      // console.log('RJMDEBUG200 old pusher deleted')
    } catch (err) {
      console.log('RJMDEBUG900 ERROR failed deleting old pusher:', err)
    }
  }

  let deviceDisplayName = 'Android Device2'
  if (uniqueDeviceId.startsWith('IOS_')) {
    deviceDisplayName = 'IOS Device'
  }

  const pusherData = {
    kind: 'http',
    app_id: sygnalAppId, // MATCHES SYGNAL ID in sygnal.yaml
    app_display_name: 'Social Club Hub',
    device_display_name: deviceDisplayName,
    profile_tag: uniqueDeviceId,
    lang: 'en',
    pushkey: tokenValue,
    data: {
      url: sygnalApiEndpoint + '/_matrix/push/v1/notify', // Your Sygnal endpoint
      format: 'event_id_only' // full not supported by
    },
    append: true
  }

  // console.log('RJMDEBUG200 About to register push token:', JSON.stringify(pusherData))

  try {
    await matrixClient.setPusher(pusherData)
  } catch (err) {
    console.log('RJMDEBUG900 ERROR Failed to register pusher:', err)
  }
}
